import { FormInput, FormInputProps } from 'modules';
import React from 'react';

const ChattelSelect = (props: FormInputProps) => {
  const options = [
    {
      label: 'Nie ste vlastníkom žiadneho hnuteľného majetku.',
      value: 'Nie ste vlastníkom žiadneho hnuteľného majetku.',
    },
    {
      label: 'Motorové vozidlo (auto)',
      value: 'Motorové vozidlo (auto)',
    },
    {
      label: 'Motorové vozidlo (motocykel)',
      value: 'Motorové vozidlo (motocykel)',
    },
    {
      label: 'Motorové vozidlo (iné)',
      value: 'Motorové vozidlo (iné)',
    },
    {
      label: 'Cennosti',
      value: 'Cennosti',
    },
    {
      label: 'Bankový účet',
      value: 'Bankový účet',
    },
    {
      label: 'Důchodkové sporenie',
      value: 'Důchodkové sporenie',
    },
    {
      label: 'Kapitálové (investičné) životné poistenie',
      value: 'Kapitálové (investičné) životné poistenie',
    },
    {
      label: 'Investície (dlhopisy, akcie, fondy)',
      value: 'Investície (dlhopisy, akcie, fondy)',
    },
    {
      label: 'Elektronika (televízia, pc, notebook, smartphone, tablet)',
      value: 'Elektronika (televízia, pc, notebook, smartphone, tablet)',
    },
    {
      label: 'Obchodné podiel v spoločnosti (s.r.o. - a.s.)',
      value: 'Obchodné podiel v spoločnosti (s.r.o. - a.s.)',
    },
    {
      label: 'Iné',
      value: 'Iné',
    },
  ];

  return <FormInput {...props} type={'select'} options={options} />;
};

export default ChattelSelect;
